import { decorate } from "mobx";
import ApiClient from "utils/ApiClient";

class ConfigStore {
    config = {}
    constructor(appStore) {
        this.appStore = appStore;
    }

    get isProfileEditorOpen() {
        return !!this.user && (!this.user?.first_name || !this.user?.last_name)
    }

    async fetchInitialData() {
        await Promise.all([this.fetchConfig()]);
    }

    async fetchConfig() {
        try {
            const response = await ApiClient.Config.getConfig();
            this.config = response.data;
            window.mainDomain = response.data.site.main_domain;
            window.serverUrl = response.data.site.server_url;
            this.appStore.emailIntegrationsStore.setOAuth2ClientDataRedirectUrl();
        } catch (e) {
            console.error(e);
        }
    }
}

decorate(ConfigStore, {
});
export default ConfigStore;
